import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Guard } from '../../components/layout/Guard';

const DocumentsPage = lazy(() => import('./DocumentsPage'));

const routes: RouteObject[] = [{ path: '/documents', element: <Guard any={['doc.read']}><DocumentsPage /></Guard> }];
export default routes;
